import { useEffect } from 'react';
import { useSales } from '../store/salesStore';
import { toast } from 'sonner';

function formatDate(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString();
}

function Sales() {
  const { sales, totalSales, totalRevenue, isLoading, error, fetchSales } = useSales();

  useEffect(() => {
    fetchSales().catch((e: Error) => toast.error(e.message));
  }, [fetchSales]);

  return (
    <div className="container">
      <h1 className="page-title">Sales</h1>
      <p className="page-subtitle">
        {totalSales} sale{totalSales === 1 ? '' : 's'} —{' '}
        <strong style={{ color: 'var(--success)' }}>€{totalRevenue.toFixed(2)}</strong> total
        revenue.
      </p>

      {error && <p className="form-error">{error}</p>}

      {isLoading && sales.length === 0 ? (
        <div className="loading-spinner">
          <div className="spinner" />
        </div>
      ) : sales.length === 0 ? (
        <div className="panel">
          <div className="empty-state">
            <p>No sales recorded yet.</p>
          </div>
        </div>
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Asset</th>
                <th>Buyer</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Discount</th>
                <th>Status</th>
                <th>Purchased</th>
              </tr>
            </thead>
            <tbody>
              {sales.map((sale) => (
                <tr key={sale.id}>
                  <td>{sale.asset_name}</td>
                  <td>{sale.buyer_name}</td>
                  <td>€{sale.price.toFixed(2)}</td>
                  <td>{sale.quantity}</td>
                  <td>
                    {sale.discount_amount > 0 ? (
                      <span className="voucher-tag" title={sale.voucher_code ?? ''}>
                        -€{sale.discount_amount.toFixed(2)}
                        {sale.voucher_code ? ` (${sale.voucher_code})` : ''}
                      </span>
                    ) : (
                      '—'
                    )}
                  </td>
                  <td>
                    <span className={`status-badge status--${sale.status}`}>{sale.status}</span>
                  </td>
                  <td>{formatDate(sale.purchased_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Sales;
